import { render, staticRenderFns } from "./CandelaControl.vue?vue&type=template&id=cd83ddca&"
import script from "./CandelaControl.vue?vue&type=script&lang=js&"
export * from "./CandelaControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports